/**
 * bm scope: bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415
 * editor scope: bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415
 * viewer scope:
 */
export const EXPERIMENTS = {
  /**
   * default specs
   */
  /**
   * {@link https://bo.wix.com/petri/experiments/2790047}
   * [BM] - Manage Promos from BM flow
   * Figma: {@link https://www.figma.com/file/AHVkTcukUdaI5g3BL6ilkG/Promos---BO?type=design&node-id=5929-43941&mode=design&t=9XVyK8DqD4uWAhU7-4}
   */
  MANAGE_PROMOS_BM: 'spec.wixLabs.managePromosFromBm',
  /**
   * {@link https://bo.wix.com/petri/experiments/2790047}
   * [BM] - Manage Promos from BM flow
   * Figma: {@link https://www.figma.com/design/OXiCfJpD8Y0Tk1Qm9QdIC8/Promos---BO-V.2?node-id=8454-84155&t=9ajHRYX6yYTRWeoh-4}
   */
  CREATE_WITH_WIZARD: 'spec.labs.promos.create_with_wizard'
};
//# sourceMappingURL=experiments.js.map